import * as React from 'react'

import _ from 'lodash'
import { Socket, Channel } from 'phoenix'

const channels: Record<string, Channel> = {}

let socket: Socket | null = null
let socketParams: Record<string, unknown> | null = null

export const getSocket = (
  params: Record<string, unknown>,
  { host }: { host?: string } = {},
) => {
  if (socket && _.isEqual(params, socketParams)) {
    return socket
  } else if (socket) {
    disconnectSocket()
  }

  const socketHost = host ?? ''
  socket = new Socket(`${socketHost}/s`, { params: params })
  socketParams = params
  return socket
}

export const disconnectSocket = () => {
  socket?.disconnect()
  socket = null
  socketParams = null
}

export const getChannel = (id: string, params?: object) => {
  if (channels[id] != null) {
    return channels[id]
  }
  if (!socket) {
    throw new Error('Socket is not connected. Please connect the socket first.')
  }
  const channel = socket.channel(id, params)
  channels[id] = channel
  return channel
}

export const leaveChannel = (id: string) => {
  const channel = channels[id]
  if (id in channels) {
    delete channels[id]
  }
  channel.leave()
  return channel
}

export const useChannel = (id: string) => {
  const [channel, setChannel] = React.useState<Channel | null>(null)

  React.useEffect(() => {
    setChannel(getChannel(id))
  }, [id])

  return channel
}

export default socket
